import { render, staticRenderFns } from "./RaceRoster.vue?vue&type=template&id=12528c93"
import script from "./RaceRoster.vue?vue&type=script&lang=js"
export * from "./RaceRoster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports